export enum ListViewFontWeights {
  Bold = 'bold',
  Medium = '500',
  Normal = 'normal'
}
